/* ==========================================================================
   VELOCITY — commerce (cart drawer, predictive search, product form)
   All AJAX is enhancement: every form/link still works without JavaScript.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.VELOCITY_CONFIG || {};
  var routes = CFG.routes || {};
  var strings = CFG.strings || {};
  var doc = document;

  function $(s, c) { return (c || doc).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }
  function money(v) { return v; }

  var body = doc.body;
  var lastFocus = null;

  /* ----------------------------- Cart drawer ----------------------------- */
  var drawer = $('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    lastFocus = doc.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
    var closeBtn = $('[data-drawer-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function renderCartFromSection(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newBody = parsed.querySelector('[data-cart-drawer-body]');
    var liveBody = drawer && drawer.querySelector('[data-cart-drawer-body]');
    if (newBody && liveBody) liveBody.innerHTML = newBody.innerHTML;
    var newRoot = parsed.querySelector('[data-cart-root]');
    if (newRoot) {
      var c = parseInt(newRoot.getAttribute('data-cart-count') || '0', 10);
      updateCartCount(c);
    }
  }

  function fetchAndRenderCart() {
    if (!routes.cart) return;
    fetch(routes.cart + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data['cart-drawer']) renderCartFromSection(data['cart-drawer']);
      })
      .catch(function () {});
  }

  function addToCart(form, button) {
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', routes.cart || '/cart');
    var original = button ? button.textContent : '';
    if (button) { button.classList.add('is-disabled'); button.textContent = strings.adding || 'Adding…'; }
    fetch((routes.cart_add || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (button) { button.classList.remove('is-disabled'); button.textContent = original; }
        if (!res.ok) {
          var msg = res.data && res.data.description ? res.data.description : (res.data && res.data.message) || 'Error';
          showFormError(form, msg);
          return;
        }
        if (res.data.sections && res.data.sections['cart-drawer']) {
          renderCartFromSection(res.data.sections['cart-drawer']);
        } else {
          fetchAndRenderCart();
        }
        if ((CFG.cartType || 'drawer') === 'drawer') openDrawer();
        else window.location.href = routes.cart || '/cart';
      })
      .catch(function () {
        if (button) { button.classList.remove('is-disabled'); button.textContent = original; }
        form.submit();
      });
  }

  function changeLine(key, quantity, row) {
    if (row) row.style.opacity = '0.5';
    fetch((routes.cart_change || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: routes.cart })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) renderCartFromSection(data.sections['cart-drawer']);
        else fetchAndRenderCart();
        // if on cart page, reload line totals
        if (body.classList.contains('template-cart')) window.location.reload();
        updateCartCount(data.item_count != null ? data.item_count : undefined);
      })
      .catch(function () { window.location.reload(); });
  }

  function showFormError(form, msg) {
    var box = form.querySelector('[data-form-error]');
    if (!box) { box = doc.createElement('p'); box.className = 'v-form-error'; box.setAttribute('data-form-error', ''); form.appendChild(box); }
    box.textContent = msg;
  }

  /* triggers (delegated) */
  on(doc, 'click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && (CFG.cartType || 'drawer') === 'drawer' && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-key'), 0, remove.closest('.v-cart-line')); return; }
  });
  on(doc, 'keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* quantity steppers (delegated, works in drawer + cart page + pdp) */
  on(doc, 'click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.v-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    if (minus) val = Math.max(min, val - 1); else val = val + 1;
    input.value = val;
    var key = input.getAttribute('data-line-key');
    if (key) changeLine(key, val, input.closest('.v-cart-line'));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* cart line direct qty change */
  on(doc, 'change', function (e) {
    var input = e.target.closest('input[data-line-key]');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 0) val = 0;
    changeLine(input.getAttribute('data-line-key'), val, input.closest('.v-cart-line'));
  });

  /* product forms (AJAX add) */
  $all('form[data-product-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      addToCart(form, btn);
    });
  });

  /* ------------------------- Variant selection --------------------------- */
  $all('[data-product-root]').forEach(function (rootEl) {
    var dataEl = $('[data-variants]', rootEl);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = $('form[data-product-form]', rootEl);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = $('[data-price]', rootEl);
    var addBtn = form ? form.querySelector('[type="submit"]') : null;
    var addLabel = $('[data-add-label]', rootEl);

    function currentOptions() {
      var opts = [];
      $all('[data-option-index]', rootEl).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var sel = group.querySelector('input:checked, select');
        if (sel) opts[idx] = sel.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var opts = currentOptions();
      var v = findVariant(opts);
      // mark availability of swatches
      $all('.v-variant__opt', rootEl).forEach(function (label) {
        var input = label.querySelector('input');
        if (input) label.classList.toggle('is-selected', input.checked);
      });
      if (!v) {
        if (addBtn) { addBtn.setAttribute('disabled', ''); }
        if (addLabel) addLabel.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span class="v-price__regular">' + v.price + '</span>';
        if (v.compare && v.compare_raw > v.price_raw) {
          html += ' <s class="v-price__compare">' + v.compare + '</s> <span class="v-price__badge">' + (strings.sale || 'Sale') + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); if (addLabel) addLabel.textContent = strings.addToCart || 'Add to cart'; }
        else { addBtn.setAttribute('disabled', ''); if (addLabel) addLabel.textContent = strings.soldOut || 'Sold out'; }
      }
      // gallery
      if (v.featured_media_id) {
        var slide = $('[data-media-id="' + v.featured_media_id + '"]', rootEl);
        if (slide) activateSlide(rootEl, slide);
      }
      // url
      if (history.replaceState && v.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    $all('[data-option-index] input, [data-option-index] select', rootEl).forEach(function (el) {
      on(el, 'change', update);
    });
    update();
  });

  function activateSlide(rootEl, slide) {
    $all('.v-gallery__slide', rootEl).forEach(function (s) { s.classList.remove('is-active'); });
    slide.classList.add('is-active');
    var id = slide.getAttribute('data-media-id');
    $all('.v-gallery__thumb', rootEl).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-media-id') === id);
    });
  }

  /* gallery thumbnails */
  on(doc, 'click', function (e) {
    var thumb = e.target.closest('.v-gallery__thumb');
    if (!thumb) return;
    var rootEl = thumb.closest('[data-product-root]') || doc;
    var id = thumb.getAttribute('data-media-id');
    var slide = $('[data-media-id="' + id + '"].v-gallery__slide', rootEl);
    if (slide) activateSlide(rootEl, slide);
  });

  /* --------------------------- Search modal ------------------------------ */
  var searchModal = $('[data-search-modal]');
  function openSearch() {
    if (!searchModal) return;
    searchModal.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
    var input = $('[data-predictive-search-input]', searchModal);
    if (input) setTimeout(function () { input.focus(); }, 60);
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
  }
  on(doc, 'click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });
  on(doc, 'keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

  /* predictive search */
  if (CFG.predictiveSearch && searchModal) {
    var sInput = $('[data-predictive-search-input]', searchModal);
    var sResults = $('[data-predictive-search-results]', searchModal);
    var timer = null;
    function runSearch(q) {
      if (!q || q.length < 2) { sResults.innerHTML = ''; return; }
      var url = (routes.predict || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderPredictive(data, q); })
        .catch(function () {});
    }
    function renderPredictive(data, q) {
      var res = data.resources && data.resources.results;
      if (!res) { sResults.innerHTML = ''; return; }
      var html = '<div class="v-predictive">';
      if (res.products && res.products.length) {
        html += '<div class="v-predictive__group"><h5>Products</h5>';
        res.products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=96" alt="" loading="lazy">' : '';
          html += '<a class="v-predictive__item" href="' + p.url + '">' + img + '<span><b>' + escapeHtml(p.title) + '</b><br><small class="v-muted">' + (p.price ? p.price : '') + '</small></span></a>';
        });
        html += '</div>';
      }
      if (res.articles && res.articles.length) {
        html += '<div class="v-predictive__group"><h5>Articles</h5>';
        res.articles.forEach(function (a) {
          html += '<a class="v-predictive__item" href="' + a.url + '"><span><b>' + escapeHtml(a.title) + '</b></span></a>';
        });
        html += '</div>';
      }
      if (res.pages && res.pages.length) {
        html += '<div class="v-predictive__group"><h5>Pages</h5>';
        res.pages.forEach(function (pg) {
          html += '<a class="v-predictive__item" href="' + pg.url + '"><span><b>' + escapeHtml(pg.title) + '</b></span></a>';
        });
        html += '</div>';
      }
      html += '</div>';
      var any = (res.products && res.products.length) || (res.articles && res.articles.length) || (res.pages && res.pages.length);
      sResults.innerHTML = any ? html : '<p class="v-muted" style="padding:1rem 0">No results for &ldquo;' + escapeHtml(q) + '&rdquo;</p>';
    }
    on(sInput, 'input', function () {
      clearTimeout(timer);
      var q = sInput.value.trim();
      timer = setTimeout(function () { runSearch(q); }, 220);
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  /* re-bind product forms when a section reloads in the editor */
  document.addEventListener('shopify:section:load', function (e) {
    $all('form[data-product-form]', e.target).forEach(function (form) {
      on(form, 'submit', function (ev) { ev.preventDefault(); addToCart(form, form.querySelector('[type="submit"]')); });
    });
  });

  window.VelocityCart = { open: openDrawer, close: closeDrawer, refresh: fetchAndRenderCart };
})();
